<template>
  <div class="page-container">
    <!-- 统计卡片 -->
    <div class="stats-row">
      <div class="stat-card"><div class="stat-label">总申请数</div><div class="stat-value">{{ stats.total || 0 }}</div></div>
      <div class="stat-card"><div class="stat-label">待审核</div><div class="stat-value" style="color:#e6a23c;">{{ stats.pending || 0 }}</div></div>
      <div class="stat-card"><div class="stat-label">已通过</div><div class="stat-value" style="color:#67c23a;">{{ stats.passed || 0 }}</div></div>
      <div class="stat-card"><div class="stat-label">已拒绝</div><div class="stat-value" style="color:#f56c6c;">{{ stats.rejected || 0 }}</div></div>
      <div class="stat-card"><div class="stat-label">申请失败</div><div class="stat-value" style="color:#909399;">{{ stats.failed || 0 }}</div></div>
    </div>

    <!-- 搜索 -->
    <div class="filter-bar">
      <el-form :inline="true" :model="search" size="small">
        <el-form-item label="申请编号"><el-input v-model="search.pnoNo" placeholder="请输入申请编号" clearable style="width:160px;"></el-input></el-form-item></el-form-item>
        <el-form-item label="用户ID"><el-input v-model="search.customerNo" placeholder="请输入用户ID" clearable style="width:130px;"></el-input></el-form-item>
        <el-form-item label="姓名"><el-input v-model="search.name" placeholder="请输入姓名" clearable style="width:120px;"></el-input></el-form-item>
        <el-form-item label="手机号"><el-input v-model="search.phone" placeholder="请输入手机号" clearable style="width:130px;"></el-input></el-form-item>
        <el-form-item label="邮箱"><el-input v-model="search.email" placeholder="请输入邮箱" clearable style="width:160px;"></el-input></el-form-item>
        <el-form-item label="推荐人"><el-input v-model="search.referrer" placeholder="请输入推荐人" clearable style="width:120px;"></el-input></el-form-item>
        <el-form-item label="国家">
          <el-select v-model="search.countryCode" placeholder="全部" clearable style="width:120px;">
            <el-option v-for="c in countries" :key="c.countryCode" :label="c.countryCode + ' ' + (c.countryCname||c.countryName)" :value="c.countryCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="注册方式">
          <el-select v-model="search.regWay" placeholder="全部" clearable style="width:100px;">
            <el-option label="H5" :value="1"></el-option><el-option label="Android" :value="2"></el-option>
            <el-option label="IOS" :value="3"></el-option><el-option label="PC" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户组">
          <el-select v-model="search.groupId" placeholder="全部" clearable style="width:140px;">
            <el-option v-for="g in groupOptions" :key="g.id" :label="g.groupName" :value="g.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户标签">
          <el-select v-model="search.tagId" placeholder="全部" clearable style="width:120px;">
            <el-option v-for="t in tagOptions" :key="t.id" :label="t.tagName" :value="t.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker v-model="search.createDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:260px;"></el-date-picker>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="fetchList">搜索</el-button><el-button @click="resetSearch">重置</el-button></el-form-item>
      </el-form>
    </div>

    <div class="table-wrapper">
      <div class="table-header" style="display:flex;align-items:center;justify-content:space-between;">
        <span class="table-title">开户申请列表</span>
        <div class="table-actions">
          <el-button v-auth="'business:accountApply:review'" size="small" type="primary" icon="el-icon-check" :disabled="selection.length === 0" @click="batchApprove">审批</el-button>
          <el-button v-auth="'business:accountApply:review'" size="small" type="danger" icon="el-icon-close" :disabled="selection.length === 0" @click="batchReject">拒绝</el-button>
          <el-button v-auth="'business:accountApply:export'" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>
        </div>
      </div>
      <el-tabs v-model="activeTab" @tab-click="fetchList">
        <el-tab-pane :label="'全部(' + (stats.total || 0) + ')'" name="all"></el-tab-pane>
        <el-tab-pane :label="'待审核(' + (stats.pending || 0) + ')'" name="pending"></el-tab-pane>
        <el-tab-pane :label="'已通过(' + (stats.passed || 0) + ')'" name="passed"></el-tab-pane>
        <el-tab-pane :label="'已拒绝(' + (stats.rejected || 0) + ')'" name="rejected"></el-tab-pane>
        <el-tab-pane :label="'申请失败(' + (stats.failed || 0) + ')'" name="failed"></el-tab-pane>
      </el-tabs>
      <el-table ref="applyTable" :data="tableData" border v-loading="loading" style="width:100%;" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column prop="pnoNo" label="申请编号" width="110"></el-table-column>
        <el-table-column prop="customerNo" label="用户ID" width="120"></el-table-column>
        <el-table-column prop="name" label="姓名" width="90"></el-table-column>
        <el-table-column prop="referrer" label="推荐人" width="90"></el-table-column>
        <el-table-column label="手机号" width="150"><template slot-scope="{row}">{{ (row.phonePrefix ? '+' + row.phonePrefix + ' ' : '') + (row.phoneNumber || '') }}</template></el-table-column>
        <el-table-column prop="email" label="邮箱" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="国家" width="80">
          <template slot-scope="scope">{{ countryLabel(scope.row.countryCode) }}</template>
        </el-table-column>
        <el-table-column label="注册方式" width="90">
          <template slot-scope="scope">{{ regLabel(scope.row.regWay) }}</template>
        </el-table-column>
        <el-table-column label="客户组" width="110">
          <template slot-scope="scope">{{ groupLabel(scope.row.groupId) }}</template>
        </el-table-column>
        <!-- 列宽要放得下一个 6 字标签胶囊 + 「…」（实测「KYC已拒绝」胶囊约 89px），
             和 clientAccount 的风险标签列保持同一套渲染 -->
        <el-table-column label="风险标签" width="140">
          <template slot-scope="scope">
            <!-- 只露第一个标签，多于一个时补「…」，鼠标悬浮用 tooltip 看全部标签。
                 标签名是后台自定义的，再宽的列也可能被撑爆，所以只有一个标签时也保留 tooltip
                 （tooltip 用 light 白底，彩色胶囊才看得清：胶囊底色是带透明度的） -->
            <el-tooltip
              v-if="riskTags(scope.row).length"
              placement="top"
              effect="light"
              popper-class="ctag-tip-popper"
            >
              <div slot="content" class="ctag-tip">
                <span v-for="t in riskTags(scope.row)" :key="t.n" class="ctag" :style="tagPillStyle(t.c)"><span class="ctag-dot" :style="{background: t.c}"></span>{{ t.n }}</span>
              </div>
              <span class="ctag-cell">
                <span class="ctag" :style="tagPillStyle(riskTags(scope.row)[0].c)"><span class="ctag-dot" :style="{background: riskTags(scope.row)[0].c}"></span>{{ riskTags(scope.row)[0].n }}</span>
                <span v-if="riskTags(scope.row).length > 1" class="ctag-more">…</span>
              </span>
            </el-tooltip>
            <span v-else style="color:#c0c4cc;">--</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="statusType(scope.row.approvedStatus)" size="mini">{{ statusLabel(scope.row.approvedStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="regTime" label="申请时间" width="160"></el-table-column>
        <el-table-column prop="reviewTime" label="审核时间" width="160"></el-table-column>
        <el-table-column prop="reviewer" label="审核人" width="100"></el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button v-auth="'business:accountApply:review'" v-if="scope.row.approvedStatus === 1" type="text" size="small" style="color:var(--brand-primary);" @click="openReview(scope.row)">审核</el-button>
            <el-button v-else type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="(v)=>{pageSize=v;fetchList()}" @current-change="(v)=>{pageNum=v;fetchList()}"
        :current-page="pageNum" :page-sizes="[10,50,100]" :page-size="pageSize" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog :visible.sync="detailVisible" width="900px" :close-on-click-modal="false">
      <div slot="title" style="display:flex;align-items:center;gap:12px;">
        <span>申请详情</span>
        <el-tag v-if="detail" :type="statusType(detail.approvedStatus)" size="small">{{ statusLabel(detail.approvedStatus) }}</el-tag>
      </div>
      <customer-info-tabs
        :detail="detail"
        :survey-answer="surveyAnswer"
        :countries="countries"
        :groups="groupOptions"
        @view-survey="openSurveyResult" />
      <div slot="footer"><el-button @click="detailVisible=false">关闭</el-button></div>
    </el-dialog>

    <!-- 问卷结果弹窗（详情弹窗「问卷调查」区块的「查看问卷结果」） -->
    <el-dialog :visible.sync="surveyResultVisible" width="880px" :close-on-click-modal="false">
      <div slot="title">问卷结果 - 通用模版问卷</div>
      <div style="padding:8px 0;max-height:65vh;overflow-y:auto;">
        <div v-for="(sec, si) in surveySections" :key="si" style="margin-bottom:16px;">
          <div style="font-size:13px;font-weight:600;color:#303133;margin-bottom:10px;padding:6px 10px;background:#f5f7fa;border-radius:6px;">
            第{{ si + 1 }}部分 · {{ sec.sectionName }}（{{ sec.scoringEnabled === 1 ? '计分' : '不计分' }}）
          </div>
          <div v-for="(q, qi) in (sec.questions || [])" :key="qi" style="margin-bottom:8px;padding:8px 12px;background:#fff;border:1px solid #ebeef5;border-radius:6px;">
            <div style="color:#606266;font-size:12px;">
              Q{{ qi + 1 }}. {{ q.questionText }}
              <el-tag v-if="q.isKey === 1" type="warning" size="mini" style="margin-left:6px;">关键题</el-tag>
            </div>
            <div style="display:flex;justify-content:space-between;align-items:center;margin-top:4px;">
              <span style="font-weight:500;font-size:13px;color:#303133;">{{ q.answer || '--' }}</span>
              <span v-if="q.score != null" style="color:#00897b;font-size:12px;font-weight:600;">+{{ q.score }}分</span>
            </div>
          </div>
        </div>
        <div v-if="!surveySections.length" class="empty-block">暂无答题详情</div>
      </div>
      <div slot="footer"><el-button type="primary" @click="surveyResultVisible=false">关闭</el-button></div>
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog :visible.sync="reviewVisible" width="1100px" :close-on-click-modal="false">
      <div slot="title">开户审核</div>
      <div v-if="reviewDetail" class="kyc-layout">
        <!-- 左侧：申请资料 -->
        <div class="kyc-docs">
          <div style="font-size:14px;font-weight:600;margin-bottom:8px;">申请资料</div>
          <!-- 证件图 URL 来自 /business/accountApply/detail（CustomerVo.frontImageUrl/backImageUrl/handheldImageUrl）；
               有图直接渲染缩略图（点击看原图），无图或加载失败回退占位图标 -->
          <div v-for="doc in kycDocs" :key="doc.key" class="kyc-doc-card" :class="{'is-filled': showDocImg(doc)}"
               @click="previewDoc(doc)">
            <img v-if="showDocImg(doc)" :src="doc.url" class="doc-img" alt="" @error="onDocImgError(doc.key)" />
            <div v-else class="doc-placeholder">{{ doc.icon }}</div>
            <div class="doc-label">{{ doc.label }}</div>
          </div>
        </div>
        <!-- 右侧：审核信息 -->
        <div>
          <customer-info-tabs
            :detail="reviewDetail"
            :survey-answer="surveyAnswer"
            :countries="countries"
            :groups="groupOptions"
            :show-doc-images="false"
            :show-audit-log="false"
            @view-survey="openSurveyResult" />
          <div class="detail-section" style="margin-top:16px;">
            <div class="detail-sec-title">审核结论</div>
            <div style="margin-bottom:12px;">
              <el-radio-group v-model="reviewResult">
                <el-radio label="pass">通过</el-radio>
                <el-radio label="reject">拒绝</el-radio>
              </el-radio-group>
            </div>
            <div style="margin-bottom:12px;">
              <div style="font-size:12px;color:#909399;margin-bottom:4px;">拒绝原因</div>
              <el-input v-model="reviewReason" :disabled="reviewResult!=='reject'" placeholder="请输入拒绝原因" type="textarea" :rows="2"></el-input>
            </div>
            <div>
              <div style="font-size:12px;color:#909399;margin-bottom:4px;">审核备注</div>
              <el-input type="textarea" v-model="reviewNote" :rows="3" placeholder="请输入审核备注（选填）"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="reviewVisible=false">取消</el-button>
        <el-button v-auth="'business:accountApply:review'" type="primary" @click="submitReview">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { accountApplyList, accountApplyStats, accountApplyDetail, accountApplySurveyAnswer, accountApplyReview, accountApplyReviewBatch, accountApplyExport } from '@/api/accountApply'
import { countryList } from '@/api/regConfig'
import { customerGroupList } from '@/api/customerGroup'
import { tagListAll } from '@/api/tagManagement'
// 客户资料 Tab（详情弹窗 + 审核弹窗共用同一套：申请信息/基本信息/证件信息/问卷调查/银行卡/审核信息）
import CustomerInfoTabs from './components/CustomerInfoTabs'

export default {
  name: 'AccountApplyList',
  components: { CustomerInfoTabs },
  data() {
    return {
      tableData: [], loading: false, pageNum: 1, pageSize: 10, total: 0, activeTab: 'all',
      search: { pnoNo: '', customerNo: '', name: '', phone: '', email: '', referrer: '', countryCode: '', regWay: null, groupId: null, tagId: null, createDate: null },
      stats: {}, countries: [], groupOptions: [], tagOptions: [],
      detailVisible: false, detail: null,
      // 问卷调查：答案单独接口查询（带整份 answersJson），不进详情主接口
      surveyAnswer: null, surveyResultVisible: false, surveySections: [],
      reviewVisible: false, reviewDetail: null, reviewResult: 'pass', reviewReason: '', reviewNote: '',
      // 证件图加载失败标记（key=front/back/handheld）：CDN 不可达或链接失效时回退占位图标
      docImgError: {},
      selection: []
    }
  },
  computed: {
    // 审核弹窗左侧申请资料三张证件图
    kycDocs() {
      const d = this.reviewDetail || {}
      return [
        { key: 'front', label: '身份证正面', icon: '🪪', url: d.frontImageUrl },
        { key: 'back', label: '身份证反面', icon: '🪪', url: d.backImageUrl },
        { key: 'handheld', label: '手持证件照', icon: '👤', url: d.handheldImageUrl }
      ]
    }
  },
  mounted() { this.fetchList(); this.fetchStats(); this.fetchCountries(); this.fetchGroups(); this.fetchTags() },
  methods: {
    fetchList() {
      this.loading = true
      const params = { pageNum: this.pageNum, pageSize: this.pageSize, ...this.search }
      const tabMap = { pending: 1, passed: 2, rejected: 3, failed: 4 }
      if (this.activeTab !== 'all') params.approvedStatus = tabMap[this.activeTab]
      accountApplyList(params).then(res => {
        if (res.code === 0) { this.tableData = res.result.list || []; this.total = res.result.total || 0 }
      }).finally(() => { this.loading = false })
    },
    fetchStats() { accountApplyStats().then(res => { if (res.code === 0) this.stats = res.result || {} }) },
    fetchCountries() { countryList({ pageNum: 1, pageSize: 500 }).then(res => { if (res.code === 0) this.countries = res.result.list || [] }) },
    fetchGroups() { customerGroupList({ pageNum: 1, pageSize: 500 }).then(res => { if (res.code === 0) this.groupOptions = res.result.list || [] }) },
    fetchTags() { tagListAll().then(res => { if (res.code === 0) this.tagOptions = res.result || [] }) },
    resetSearch() { this.search = { pnoNo:'',customerNo:'',name:'',phone:'',email:'',referrer:'',countryCode:'',regWay:null,groupId:null,tagId:null,createDate:null }; this.fetchList() },
    handleExport() {
      const rows = this.$refs.applyTable.selection
      const tabMap = { pending: 1, passed: 2, rejected: 3, failed: 4 }
      const params = { ...this.search }
      if (rows.length > 0) {
        params.ids = rows.map(r => r.id).join(',')
      } else if (this.activeTab !== 'all') {
        params.approvedStatus = tabMap[this.activeTab]
      }
      accountApplyExport(params).then(res => {
        const blob = res instanceof Blob ? res : new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url; a.download = '开户申请.xlsx'; a.click()
        window.URL.revokeObjectURL(url)
      })
    },
    regLabel(v) { const m={1:'H5',2:'Android',3:'IOS',4:'PC'}; return m[v]||'-' },
    statusLabel(v) { const m={1:'待审核',2:'已通过',3:'已拒绝',4:'申请失败'}; return m[v]||'-' },
    statusType(v) { const m={1:'warning',2:'success',3:'danger',4:'info'}; return m[v]||'info' },
    countryLabel(code) { const c=this.countries.find(x=>x.countryCode===code); return c?c.countryCname||c.countryName:code||'-' },
    groupLabel(id) { const g=this.groupOptions.find(x=>x.id===id); return g?g.groupName:id||'-' },
    handleSelectionChange(v) { this.selection = v },
    openDetail(row) {
      // 换一条申请要先清掉上一条的问卷，否则没做问卷的客户会看到上一条的答案
      this.surveyAnswer = null
      accountApplyDetail(row.id).then(res => {
        if (res.code === 0) {
          this.detail = res.result
          this.detailVisible = true
          this.fetchSurveyAnswer(this.detail.id)
        }
      })
    },
    // 详情弹窗传 detail.id、审核弹窗传 reviewDetail.id（两个弹窗可能不是同一条申请）
    fetchSurveyAnswer(customerId) {
      if (!customerId) return
      accountApplySurveyAnswer(customerId).then(res => {
        if (res.code === 0) this.surveyAnswer = res.result || null
      })
    },
    openSurveyResult() {
      if (!this.surveyAnswer || !this.surveyAnswer.answersJson) return
      try {
        const data = JSON.parse(this.surveyAnswer.answersJson)
        this.surveySections = data.sections || []
      } catch (e) { this.surveySections = [] }
      this.surveyResultVisible = true
    },
    openReview(row) {
      this.reviewResult = 'pass'; this.reviewReason = ''; this.reviewNote = ''
      // 换一条申请要清掉上一条的图片加载失败标记，否则同一位置会一直显示占位图标
      this.docImgError = {}
      // 审核弹窗里的「问卷调查」Tab 也要有答案，和详情弹窗共用 surveyAnswer（同一时刻只开一个弹窗）
      this.surveyAnswer = null
      accountApplyDetail(row.id).then(res => {
        if (res.code === 0) {
          this.reviewDetail = res.result
          this.reviewVisible = true
          this.fetchSurveyAnswer(this.reviewDetail.id)
        }
      })
    },
    submitReview() {
      if (this.reviewResult === 'reject' && !this.reviewReason) return this.$message.warning('请输入拒绝原因')
      accountApplyReview({
        id: this.reviewDetail.id,
        result: this.reviewResult,
        reason: this.reviewReason,
        note: this.reviewNote
      }).then(res => {
        if (res.code === 0) {
          this.$message.success(this.reviewResult === 'pass' ? '审核通过' : '已拒绝')
          this.reviewVisible = false
          this.fetchList()
          this.fetchStats()
        }
      })
    },
    // 证件图是否可展示：有 URL 且未标记加载失败
    showDocImg(doc) { return !!doc.url && !this.docImgError[doc.key] },
    onDocImgError(key) { this.$set(this.docImgError, key, true) },
    previewDoc(doc) {
      if (!this.showDocImg(doc)) return this.$message.info('暂未上传' + doc.label)
      window.open(doc.url)
    },
    // 批量审核：只对「待审核」的记录生效。已通过/已拒绝/申请失败的记录再审一次，
    // 后台会直接拒绝（已通过的再审会重复开 MT5 账户），所以这里先过滤掉并告知用户
    batchReview(result) {
      const selected = this.$refs.applyTable.selection || []
      const rows = selected.filter(r => r.approvedStatus === 1)
      const skipped = selected.length - rows.length
      if (rows.length === 0) {
        return this.$message.warning(skipped > 0 ? '选中的记录都不是「待审核」，无法审核' : '请选择申请记录')
      }
      const ids = rows.map(r => r.id).join(',')
      const skipTip = skipped > 0 ? `（另有 ${skipped} 条非待审核，已跳过）` : ''
      const ask = result === 'pass'
        ? this.$confirm(`确认通过选中的 ${rows.length} 条申请?${skipTip}`, '批量审批', { type: 'warning' })
        : this.$prompt(`确认拒绝选中的 ${rows.length} 条申请?${skipTip}`, '批量拒绝', {
          inputPlaceholder: '请输入拒绝原因',
          inputValidator: v => (v && v.trim() ? true : '拒绝原因不能为空')
        })
      ask.then(input => {
        const reason = input && input.value ? input.value : ''
        accountApplyReviewBatch({ ids, result, reason, note: '' }).then(res => {
          if (res.code !== 0) return
          const data = res.result || {}
          const fail = data.failCount || 0
          if (data.successCount > 0) {
            this.$message.success(`已${result === 'pass' ? '通过' : '拒绝'} ${data.successCount} 条`)
          }
          if (fail > 0) {
            this.$alert((data.failures || []).map(v => this.escapeHtml(v)).join('<br>'), `以下 ${fail} 条审核失败`, {
              type: 'error',
              dangerouslyUseHTMLString: true
            })
          }
          this.$refs.applyTable.clearSelection()
          this.fetchList()
          this.fetchStats()
        })
      }).catch(() => {})
    },
    batchApprove() { this.batchReview('pass') },
    batchReject() { this.batchReview('reject') },
    // 风险标签列：和 clientAccount 的客户标签列共用同一套胶囊渲染
    tagPillStyle(c) {
      return { background: this.colorAlpha(c, 0.125), color: c, border: '1px solid ' + this.colorAlpha(c, 0.25) }
    },
    /** 解析风险标签 JSON，返回 [{n: 名称, c: 颜色}]；空值/脏数据返回空数组 */
    riskTags(row) {
      const raw = row && row.riskTagsJson
      if (!raw) return []
      try {
        const arr = typeof raw === 'string' ? JSON.parse(raw) : raw
        return Array.isArray(arr) ? arr.filter(t => t && t.n) : []
      } catch (e) { return [] }
    },
    // 标签颜色后端存的是十六进制或 rgba() 两种格式，统一转成带透明度的 rgba
    colorAlpha(c, alpha) {
      const color = String(c == null ? '' : c).trim()
      let m = /^#([0-9a-f]{3})$/i.exec(color)
      if (m) { const h = m[1]; return `rgba(${parseInt(h[0]+h[0],16)}, ${parseInt(h[1]+h[1],16)}, ${parseInt(h[2]+h[2],16)}, ${alpha})` }
      m = /^#([0-9a-f]{6})$/i.exec(color)
      if (m) { const h = m[1]; return `rgba(${parseInt(h.slice(0,2),16)}, ${parseInt(h.slice(2,4),16)}, ${parseInt(h.slice(4,6),16)}, ${alpha})` }
      m = /^rgba?\(([^)]+)\)$/i.exec(color)
      if (m) { const p = m[1].split(','); return `rgba(${p[0]}, ${p[1]}, ${p[2]}, ${alpha})` }
      return `rgba(90, 101, 120, ${alpha})`
    },
    escapeHtml(v) {
      return String(v).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))
    }
  }
}
</script>

<style scoped>
.page-container { padding: 16px; }
.stats-row { display: flex; gap: 12px; margin-bottom: 16px; }
.stat-card { background: #fff; border-radius: 4px; padding: 16px 20px; flex: 1; text-align: center; }
.stat-label{font-size:12px;color:#909399;margin-bottom:4px;}
.stat-value{font-size:24px;font-weight:600;color:#303133;}
.filter-bar{background:#fff;padding:12px;border-radius:4px;margin-bottom:12px;}
.table-wrapper{background:#fff;border-radius:4px;padding:16px;}
.table-header{margin-bottom:8px;}
.table-title{font-size:15px;font-weight:600;}
/* 审核结论区块（审核弹窗 Tab 下方） */
.detail-section{margin-bottom:12px;}
.detail-sec-title{font-size:14px;font-weight:600;color:#303133;margin-bottom:12px;padding-bottom:8px;border-bottom:1px solid #ebeef5;}
.kyc-layout{display:grid;grid-template-columns:280px 1fr;gap:24px;}
.kyc-docs{display:flex;flex-direction:column;gap:12px;}
.kyc-doc-card{background:#f5f7fa;border:1px solid #ebeef5;border-radius:8px;padding:20px;text-align:center;cursor:pointer;transition:all 0.2s;}
.kyc-doc-card:hover{border-color:var(--brand-primary);background:var(--brand-primary-light);}
.doc-placeholder{font-size:40px;margin-bottom:8px;}
.doc-label{font-size:12px;color:#909399;}
/* 有图时收紧内边距，缩略图铺满卡片宽度 */
.kyc-doc-card.is-filled{padding:8px;}
.doc-img{display:block;width:100%;height:120px;object-fit:cover;border-radius:6px;background:#fff;}
.kyc-doc-card.is-filled .doc-label{margin-top:6px;}
/* 问卷结果弹窗的空态 */
.empty-block{text-align:center;padding:40px;color:#9ca3af;font-size:13px;}
/* 风险标签列（和 clientAccount 的客户标签列一致）：彩色胶囊 + 只展示第一个 + 「…」+ 悬浮 tooltip 看全部 */
.ctag{display:inline-flex;align-items:center;gap:4px;padding:3px 10px;border-radius:20px;font-size:12px;font-weight:500;margin-right:4px;white-space:nowrap;}
.ctag-dot{width:6px;height:6px;border-radius:50%;flex-shrink:0;}
.ctag-cell{display:inline-flex;align-items:center;max-width:100%;}
.ctag-cell .ctag{margin-right:0;}
.ctag-more{margin-left:2px;color:#9ca3af;font-size:12px;font-weight:500;flex-shrink:0;}
.ctag-tip{display:flex;flex-wrap:wrap;max-width:260px;row-gap:6px;}
</style>
